import { validateTidalLicense } from "../base/index.js";
validateTidalLicense();
export * from "@workwave-tidal/foundation/hooks";
//# sourceMappingURL=index.js.map
